<template>
  <div class="account-settings-info-view">
    <a-form :form="form">

      <a-table :columns="userColumns" :dataSource="weiyuanhuiList" :pagination="false" rowKey="id" :scroll="{ y: 300 }" bordered>
            <span slot="name" slot-scope="name,record">
               {{record.name}}
            </span>
          <span slot="area_type" slot-scope="name,record">
              <p v-if="record.area_type==1">省级</p>
              <p v-else-if="record.area_type==2">市级</p>
              <p v-else="record.area_type==3">区级</p>
            </span>
        <template slot="action" slot-scope="text,record,index">
          <a-divider type="vertical" />
          <a-popconfirm title="确定删除此人员吗" @confirm="deleteUser(record,index)"  okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
        </template>
      </a-table>
    </a-form>

  </div>
</template>

<script>
  import { getSubWyhList } from '@/api/wyh'
  import RSwitch from '@/components/RSwitch/'
  import UserPicker from '@/components/UserPicker/'
  export default {
    components: {
      RSwitch,
      UserPicker
    },
    data () {
      return {
        saveLoading:false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        form: this.$form.createForm(this),

        //人员管理表头
        userColumns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '80px'
          },
          {
            title: '单位名称',
            dataIndex: 'name',
            scopedSlots: { customRender: 'name' },
          },
          {
            title: '类型',
            width:'100px',
            dataIndex: 'area_type',
              scopedSlots: { customRender: 'area_type' },
          },
                /*
          {
            title: '操作',
            dataIndex: 'action',
            width: '150px',
            scopedSlots: { customRender: 'action' },
          }*/
        ],
        weiyuanhuiList:[
        ],

        userFormData:{
          user_id:undefined,
          type: undefined,
        },
      }
    },
    mounted(){
      let that = this;
      that.fetch();
    },
    methods: {
      fetch(){
        let that = this;
          getSubWyhList().then(res => {
          that.weiyuanhuiList = res.data
        })

      },
    }
  }
</script>

<style lang="less" scoped>

  .avatar-upload-wrapper {
    height: 200px;
    width: 100%;
  }

  .ant-upload-preview {
    position: relative;
    margin: 0 auto;
    width: 100%;
    max-width: 180px;
    border-radius: 50%;
    box-shadow: 0 0 4px #ccc;

  .upload-icon {
    position: absolute;
    top: 0;
    right: 10px;
    font-size: 1.4rem;
    padding: 0.5rem;
    background: rgba(222, 221, 221, 0.7);
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.2);
  }
  .mask {
    opacity: 0;
    position: absolute;
    background: rgba(0,0,0,0.4);
    cursor: pointer;
    transition: opacity 0.4s;

  &:hover {
     opacity: 1;
   }

  i {
    font-size: 2rem;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -1rem;
    margin-top: -1rem;
    color: #d6d6d6;
  }
  }

  img, .mask {
    width: 100%;
    max-width: 180px;
    height: 100%;
    border-radius: 50%;
    overflow: hidden;
  }
  }
</style>